<p-dialog
  header="Error"
  [(visible)]="showDialog"
  [modal]="true"
  [style]="{ margin: '0 2rem', minWidth: '300px' }"
>
  <ng-template pTemplate="header">
    <div class="flex flex-column">
      <img src="assets/icons/sp_alert.svg" width="56" height="56" alt="" />
      <span class="t-20-600-primary">Su sesión está próxima a expirar</span>
    </div>
  </ng-template>
  <ng-template pTemplate="content"> 
    <p class="t-14-400-dark">¿Desea mantener la sesión activa?</p>
  </ng-template>
  <ng-template pTemplate="footer" class="pt-5">
    <p-button label="Aceptar" (click)="refreshToken()"></p-button>
  </ng-template>
</p-dialog>
